import {slugify} from 'helpers/links';
import {useCreateAction, useAllActions} from './actions';

const FLASHCARD_REVEAL = 'response/flash_card_reveal';
const MC_RESPONSE = 'response/multiple_choice';
const TEXT_RESPONSE = 'response/text';
const SELF_CHECK_RESPONSE = 'response/selfcheck';
const CONFIDENCE_CHECK_RESPONSE = 'response/confidence_check';

const getQuestionId = (questionType, promptText) => {
  // may want to limit the length of this slug
  return slugify(`${questionType} ${promptText}`);
};

const useCreateResponse = responseType => prompt => {
  const isSSR = typeof window === 'undefined';
  if (isSSR) return [{}, () => {}, {}];

  const questionId = getQuestionId(responseType, prompt);

  const createAction = useCreateAction();
  const createResponse = value => createAction(responseType, {questionId, value});

  const actions = useAllActions();
  const responses = actions.filter(
    action => action.actionType === responseType && action.payload.questionId === questionId
  );
  const latestResponse = responses[responses.length - 1];

  return [latestResponse, createResponse, responses];
};

const useMCResponse = useCreateResponse(MC_RESPONSE);
const useTextResponse = useCreateResponse(TEXT_RESPONSE);
const useSelfCheckResponse = useCreateResponse(SELF_CHECK_RESPONSE);
const useFlashCardRevealResponse = useCreateResponse(FLASHCARD_REVEAL);
const useConfidenceCheckResponse = useCreateResponse(CONFIDENCE_CHECK_RESPONSE);

export {
  useMCResponse,
  useTextResponse,
  useSelfCheckResponse,
  useFlashCardRevealResponse,
  useConfidenceCheckResponse,
};
